import { Dropdown } from 'antd'
import { observer } from 'mobx-react'
import { ReactNode, useState } from 'react'
import { MyBtn } from '~/components/ui/MyBtn'
import { MyImage } from '~/components/ui/MyImage'
import { useStores } from '~/hooks/useStores'
import { UserModal } from './UserModal'
import { CDNImage } from '~/components/business/CDNImage'
import { MyAvatar } from '~/components/ui/MyAvatar'

export const UserEntry: React.FC = observer(() => {
  const { store } = useStores()
  const [userModalVisible, setUserModalVisible] = useState(false)

  return (
    <Dropdown
      placement="bottomRight"
      dropdownRender={() => (
        <UserModal close={() => setUserModalVisible(false)} />
      )}
      trigger={['click']}
      open={userModalVisible}
      onOpenChange={visible => setUserModalVisible(visible)}
      getPopupContainer={(triggerNode: HTMLElement) =>
        triggerNode.parentNode as HTMLElement
      }
      overlayClassName="shodow-dm"
    >
      <div className="relative cursor-pointer">
        <MyImage
          tag="v400"
          className="cursor-pointer w-6 h-6 rounded-[50%] ml-6 border border-transparent hover:border-primary transition-all"
          lazy={false}
          src={store.userinfo?.avatarUrl}
          dark
        />
        {store.userinfo?.memberDetail?.hold && (
          <CDNImage
            className="absolute -bottom-[2px] -right-[2px] w-4 h-4"
            src="/images/icons/vip-icon.svg"
          />
        )}
      </div>
    </Dropdown>
  )
})
